import { IComplainerFilterItem, IFilterItem } from 'src/@complaints/interfaces';
import { actionTypes } from 'src/@complaints/actionTypes';
import { TSource } from 'src/app/props';

export const updateSelectedFilterItems = (
  category: string,
  selectedItems: IFilterItem[],
  dispatcher: any
): void => {
  dispatcher({
    type: actionTypes.UPDATE_SELECTED_FILTER_ITEMS,
    data: { category, selectedItems },
  });
};

export const clearSelectedFilterItems = (dispatcher: any): void => {
  dispatcher({ type: actionTypes.CLEAR_SELECTED_FILTER_ITEMS });
};

export const updateRangeFilter = (
  type: string,
  value: string,
  field: TSource,
  dispatcher: any
) => {
  dispatcher({ type: actionTypes.UPDATE_RANGE_FILTER, data: { type, value, field } });
};

export const updateComplainerFilter = (
  complainer: IComplainerFilterItem | null,
  dispatcher: any
) => {
  dispatcher({ type: actionTypes.UPDATE_COMPLAINER_FILTER, data: { complainer } });
};

export const updateComplaintIDFilter = (
  complaintID: string,
  dispatcher: any
) => {
  dispatcher({ type: actionTypes.UPDATE_COMPLAINT_ID_FILTER, data: { complaintID } });
};